// extracted by mini-css-extract-plugin
export default {"select":"styles_select__NzjJP","label":"styles_label__Fmny0","languageIcon":"styles_languageIcon__0lZT1"};